<div class="home-dial">
  <div class="home-dial-div">
    {{ 'HomeDialContent' | translate }}
  </div>
  <a
    class="home-dial-button"
    mat-flat-button
    (click)="onNoClick()"
    [href]="
      ua == 'iphone'
        ? 'https://apps.apple.com/us/app/valdoise-mybalade/id990253291?l=fr&ls=1'
        : 'https://play.google.com/store/apps/details?id=com.irealite.mybalade'
    "
    color="accent"
  >
    {{ 'ContinueDDL' | translate }}
  </a>
  <button
    class="home-dial-button"
    mat-flat-button
    (click)="onNoClick()"
    color="accent"
  >
    {{ 'ContinueSite' | translate }}
  </button>
</div>
